import React from 'react';
import styled from 'styled-components';

import NoticeContent from '@/components/notice/NoticeContent';
import Footer from '@/components/common/Footer';
import { Outlet, useLocation } from 'react-router-dom';
import RenewalNotification from '@/components/common/RenewalNotification';
import UpdateBanner from '@/components/common/UpdateBanner';

function Notice() {
  const { state } = useLocation();

  return (
    <Container>
      <UpdateBanner />
      {/* <RenewalNotification /> */}
      {state ? <Outlet /> : <NoticeContent />}
      <Footer />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 1080px;
  height: 100vh;
  flex: 1;
  overflow-y: scroll;
  background-color: ${(props) => props.theme.blueColors.scale3};
`;

export default Notice;
